const theme = {
  colors: {
    // Legacy colors - used by BO section
    amiOrange: "#EB3300",
    errorRed: "#ff0000",
    myDetailsGrey: "#f2f2f2",
    myFilesRed: "#cc1400",
    myFilesTextGrey: "#393b38",
    semiTransparentWhite: "rgba(255,255,255,0.5)",

    // '25 Redesign Colors
    white: "#fff",
    black: "#000",
    brightOrange: "#ffa500",
    primaryDark: "#333",
    primaryDarkAccent: "#646464",
    primaryLight: "#fff5ee",
    primaryOrange: "#f9423a",
    disabledButtonFg: "#bfbfbf",
    disabledButtonBg: "#d9d9d9",
    greyLight: "#d3d3d3",
    greyMedium: "#c4c2c2",
    greyDark: "#797979",
    red: "#cc1400",
    green: "#018210",
    testDriveBlue: "#20aff0",
  },
  breakPoints: {
    smallMobile: "375px",
    largeMobile: "475px",
    tablet: "640px",
    tabletLarge: "768px",
    desktop: "1024px",
    wideScreen: "1600px",
  },
  fontSizes: {
    xs: ".65rem",
    sm: ".875rem",
    default: "1rem",
    md: "1.125rem",
    lg: "1.5rem",
    xl: "1.9rem",
    xxl: "2.5rem",
    xxxl: "3.5rem",
    giant: "3.75rem",
  },
};

export default theme;
